import { C } from "../utils/tokens";
import { Tag } from "./primitives";
import { STEPS } from "../utils/tokens";

const Nav = ({ page, step, tpl, onLogo }) => (
  <nav
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 28px",
      height: 58,
      background: "rgba(8,9,9,0.88)",
      backdropFilter: "blur(22px)",
      borderBottom: `1px solid ${C.border}`,
    }}
  >
    <button
      onClick={onLogo}
      style={{ background: "none", border: "none", padding: 0 }}
    >
      <span
        style={{
          fontFamily: "'Syne',sans-serif",
          fontSize: 17,
          fontWeight: 800,
          background: `linear-gradient(135deg,${C.gold},#E08800)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        CVcraft
      </span>
    </button>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      {tpl && page === "builder" && (
        <Tag color={tpl.color}>
          {tpl.icon} {tpl.name}
        </Tag>
      )}
      {page === "builder" && (
        <Tag>
          {step}/{STEPS.length}
        </Tag>
      )}
      {page === "picker" && <Tag>16 template</Tag>}
    </div>
  </nav>
);

export default Nav;
